import {
  getAudienceQueryOptions,
  getAudiencesByAdAccountQueryOptions,
} from "../../queries/audiences";
import { getAdvertisersQueryOptions } from "../../queries/advertisers";
import { getAccountsQueryOptions } from "../../queries/accounts";

// necessary entities are pre-fetched when a user hover a 'edit audience' link
export const audienceFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getAdvertisersQueryOptions());
  queryClient.ensureQueryData(getAccountsQueryOptions());
};

// audiences are pre-fetched when a user hover a 'audiences' link within a adAccount
export const audienceListByAdAccountLoader = ({
  params,
  context: { queryClient },
}) => {
  const { adAccountId } = params;
  queryClient.ensureQueryData(
    getAudiencesByAdAccountQueryOptions(adAccountId, queryClient)
  );
};

// audience is pre-fetched when a user hover a 'view audience' link
export const audienceViewLoader = ({ params, context: { queryClient } }) => {
  const { audienceId } = params;
  queryClient.ensureQueryData(
    getAudienceQueryOptions(audienceId, queryClient)
  );
};
